import { GetItemsRequest, GetItemsResponse } from '../../types';
import { MicroserviceRequest } from '../../../../utils/request/microservice.request';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';
import { CompanyFilterDashboardDataProvider } from './CompanyFilterDashboardDataProvider';

export class CompanyFilterDashboardEsDataProvider extends CompanyFilterDashboardDataProvider {
  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await MicroserviceRequest.makeRequest<GetCompaniesRequest, GetCompaniesResponse>(
        'ProtectedEntities',
        'getCompaniesWithCount',
        {
          limit: request.limit,
          params: {
            includeOwnCompanyIfInTargetsOnlyOwnCompany: true,
            includeOnlyWithFullAccess: true,
          },
        }
      );

      return {
        items: response.targets.map(({ companyId, companyName }) => ({ value: companyId, label: companyName })),
        totalItemsCount: response.totalCount,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await MicroserviceRequest.makeRequest<GetCompaniesRequest, GetCompaniesResponse>(
        'ProtectedEntities',
        'getCompaniesWithCount',
        {
          page: request.page,
          limit: request.limit,
          companyName: request.searchValue,
          params: {
            includeOwnCompanyIfInTargetsOnlyOwnCompany: true,
            includeOnlyWithFullAccess: true,
          },
        }
      );

      return {
        items: response.targets
          ? response.targets.map(({ companyId, companyName }) => ({ value: companyId, label: companyName }))
          : [],
        totalItemsCount: response.totalCount,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
